/**
 * A list of implemented actions for the tree reducer.
 */
var ACTIONS = {
  collapseNode: 'collapseNode',
  collapseAllNodes: 'collapseAllNodes',
  expandNode: 'expandNode',
  highlightNode: 'highlightNode',
  moveDown: 'moveDown',
  moveUp: 'moveUp',
  filterNodes: 'filterNodes',
  regenerateTree: 'regenerateTree',
  moveNode: 'moveNode',
  addChildNodes: 'addChildNodes'
};
export default ACTIONS;
//# sourceMappingURL=actions.js.map